import SideMenuImage from './SideMenuImage';

export default SideMenuImage;
